import React, { useEffect, useRef, useState } from "react";
import useFreeTrial from "../../hooks/useFreeTrial";

export default function LandingOnlineBanner() {
  const { handleFreeTrial } = useFreeTrial();

  const [imageLoaded, setImageLoaded] = useState(false);
  const containerRef = useRef(null);
  const imageRef = useRef(null);

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        } 
      });
    };

    const handleImageIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("image-animation");
          setTimeout(() => {{
            setImageLoaded(true);
          }}, 750);
          
        } 
      });
    };

    // Creamos el IntersectionObserver
    const containerObserver = new IntersectionObserver(handleIntersection, observerOptions);
    const imageObserver = new IntersectionObserver(handleImageIntersection, observerOptions);
    

    // Observamos los componentes
    if (containerRef.current) containerObserver.observe(containerRef.current);
    if (imageRef.current) imageObserver.observe(imageRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) containerObserver.unobserve(containerRef.current);
      if (imageRef.current) imageObserver.unobserve(imageRef.current);
    };
  }, []);

  return (
    <div
      id="metodo"
      className="online__banner-outer w-100"
    >
      <div
        ref={containerRef}
        className="online__banner pt-5 d-flex align-items-center justify-content-between opacity-0"
        style={{ paddingBottom: 16 }}
      >
      <div className="banner__content">
        <h6 className="content__tbm-name mb-1">The Body Method</h6>
        <h1 className="content__title mb-1">Un método que le da dirección a tu entrenamiento y a tu proceso</h1>
        <p className="content_description py-3">
          Combinamos distintas formas de entrenamiento dentro de una estructura clara para lograr un programa más completo, eficiente y sostenible. Así, cada clase suma a tu progreso con una intención específica, estrategica y divertida. 
        </p>
        <div className="text-md-start text-center w-100">
          <button type="button" onClick={handleFreeTrial} className="btn btn-primary">Pruébalo 7 días gratis</button>
        </div>
      </div>

      <div className="banner__image-container " ref={imageRef}>
        <div className="image-overlay"></div>
        <img alt="método" src="https://thebodymethod.s3.us-west-1.amazonaws.com/tbmonline-landing-metodo.jpg" />
        <h3 className={`image-container__cardio ${imageLoaded ? "image-animation" : "opacity-0"}`} >Cardio</h3>
        <h3 className={`image-container__fuerza ${imageLoaded ? "image-animation" : "opacity-0"}`} >Fuerza</h3>
        <h3 className={`image-container__barre ${imageLoaded ? "image-animation" : "opacity-0"}`} >Barre & Pilates</h3>
      </div>
      </div>
    </div>
  );
}
